import { render, staticRenderFns } from "./CardTarjaEnqueteCopaTVFechadaQRCODE.vue?vue&type=template&id=1e7bf2ae&scoped=true"
import script from "./CardTarjaEnqueteCopaTVFechadaQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteCopaTVFechadaQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteCopaTVFechadaQRCODE.vue?vue&type=style&index=0&id=1e7bf2ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7bf2ae",
  null
  
)

export default component.exports